import { isEmpty } from 'lodash';

export const getPhotoCardConfirmedStatus = (photoCard) => {
  if (photoCard.visibility && !isEmpty(photoCard.confirmedAt)) {
    return 'approved';
  }
  if (photoCard.visibility && isEmpty(photoCard.confirmedAt)) {
    return 'pending';
  }
  return 'rejected';
};
